import TypeCard, {
  TypeCardImage,
  TypeCardTitle,
  TypeCardPrice,
  TypeCardBenefitList,
  TypeCardHeader,
  TypeCardIngress,
  TypeCardButton,
  ButtonAction,
} from "./TypeCard";
import { useContractTypeUpgradeAction } from "./UpgradeContractButton";
import styled from "styled-components";
import { GetContractUpgradeProductsResponse } from "./ContractTypePage";
import { ContractTypeBenefit } from "./ContractTypeBenefit";
import { ContractType } from "../model/ContractViewModel";
import NokPrice from "@teamscheme/nok-price";
import { ContractUpgradeProduct } from "../../payments/PaymentViewModel";
import ErrorMessage from "../../shared/error/ErrorMessage";
import SimpleCardIllustration from "./illustrations/simple_92x82.svg";
import { getContractTypeKey } from "../create-contract/ContractTypeName";

export const SIMPLE_BENEFITS: ContractTypeBenefit[] = [
  { label: "InkSign fingersignatur", positive: true },
];

export const SimplePackageDetails = () => (
  <p>
    Dette nivået på NAF Kjøpekontrakt gir brukerne tilgang til «InkSign»
    signeringsmetoden gratis. Trygg lagring betyr at du har tilgang til og kan
    laste ned kontrakten så lenge NAF lagrer den (to år).
  </p>
);

export interface SimpleCardProps {
  product: ContractUpgradeProduct;
  className?: string;
  buttonLabel?: string;
  buttonAction: ButtonAction;
  error?: boolean;
}

const SimpleCard = styled(function (props: SimpleCardProps) {
  const { product, className, buttonLabel, buttonAction, error } = props;
  const typeKey = getContractTypeKey(product.contractType);

  return (
    <TypeCard className={className}>
      <TypeCardHeader>
        <TypeCardImage
          src={SimpleCardIllustration}
          alt="Enkel"
          width="92"
          height="82"
        />
        <TypeCardTitle>Enkel</TypeCardTitle>
        <TypeCardIngress>
          Kun kontrakt med enkel digital signering.
        </TypeCardIngress>
      </TypeCardHeader>
      <TypeCardBenefitList benefits={SIMPLE_BENEFITS} />
      <TypeCardPrice>
        <NokPrice value={product.price} />
      </TypeCardPrice>
      <TypeCardButton typeKey={typeKey} action={buttonAction}>
        {buttonLabel}
      </TypeCardButton>
      {error ? (
        <ErrorMessage>En feil har oppstått! Prøv igjen.</ErrorMessage>
      ) : null}
    </TypeCard>
  );
})``;

export default SimpleCard;

export const SimpleUpgradeCard = styled(
  ({
    upgrade,
    className,
  }: {
    upgrade: GetContractUpgradeProductsResponse;
    className?: string;
  }) => {
    const client = useContractTypeUpgradeAction(upgrade, ContractType.Simple);

    const { error, action } = client;

    const baseProps = {
      className,
      product: client.product,
      buttonLabel: "Velg",
      buttonAction: action,
      error: !!error,
    };

    return <SimpleCard {...baseProps} />;
  }
)``;
